<template>
  <v-container v-if="isShow">
    <v-row>
      <v-col cols="12" class="pt-6">
        <span style="font-size: x-large"> {{ headerTitle }} </span>
        <span v-if="headerHasMore"> <router-link to="/channel">更多 &gt; </router-link></span>
      </v-col>
      <div style="width:100%;height:100%;">
        <div class="grid-session-box"
             :style="{'--videoRowNum':videoRowNum,'--videoColumnNum':videoColumnNum,
             '--gridEnd':gridEnd,'--videoColumnPercentage':videoColumnPercentage}">
          <video-card
              class="grid-item"
              v-for="(video,i) in paginatedData.list"
              :key="video.videoName"
              :size="(gridEnd==3&&i==0)?true:false"
              :value="video"
          ></video-card>
        </div>
      </div>
    </v-row>
    <div class="text-center pt-md-12" v-if="isPaging">
      <v-pagination
          v-model="requestForm.pageIndex"
          :length="paginatedData.pageCount"
          :total-visible="7"
          @input="loadData"
          color="#000"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import * as videoApi from '@/servers/video'
import {mapState} from "vuex";

export default {
  name: "VideoList",
  props: {
    headerTitle: {
      type: String,
      default: "热门视频",
    },
    headerHasMore: {
      type: Boolean,
      default: true,
    },
    firstIsEnlarge: {
      type: Boolean,
      default: true,
    },
    isPaging: {
      type: Boolean,
      default: true,
    },
    hotVideo: {
      type: Boolean,
      default: true,
    },
    autoLoad: {
      type: Boolean,
      default: false,
    },
    indexVideo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VideoCard: () => import('@/components/video/VideoCard'),
  },

  data: () => ({
    requestForm: {
      channelId: 0,
      classId: 0,
      hotVideo: 0,
      pageIndex: 1,
      pageSize: 27,
      videoName: ""
    },
    paginatedData: {
      pageNow: 1,
      pageSize: 27,
      pageCount: 0,
      count: 0,
      list: [],
    },
  }),

  computed: {
    ...mapState(['videoFilterItem', 'videoSearchKeyword']),
    gridEnd() {
      if (this.firstIsEnlarge) {
        return 3;
      } else {
        return 1;
      }
    },
    videoRowNum() {
      return Math.ceil((this.paginatedData.pageSize - 7) / 5)
    },
    videoColumnNum() {
      let n = 5;
      if (this.$vuetify.breakpoint.mobile) {
        n = 2;
      }
      return n;
    },
    videoColumnPercentage() {
      let n = '20%';
      if (this.$vuetify.breakpoint.mobile) {
        n = '50%';
      }
      return n;
    },
    isShow() {
      let show = true;
      if (this.hotVideo && this.paginatedData.count === 0) {
        show = false;
      }
      return show;
    }
  },
  methods: {

    loadData() {
      let that = this;
      if (that.hotVideo) {
        that.requestForm.hotVideo = 1;
      } else {
        that.requestForm.hotVideo = 0;
      }
      if (that.indexVideo) {
        that.requestForm.indexVideo = 1;
        delete that.requestForm.hotVideo;
      } else {
        // that.requestForm.indexVideo = 0
      }
      // console.log(this.requestForm);
      videoApi.videoList(that.requestForm)
          .then(res => {
            that.paginatedData = res;
          });
    }
  },
  created() {
    if (this.autoLoad) {
      this.loadData();
    }
  },
  watch: {
    page() {
      window.scrollTo(0, 0)
    },
    videoSearchKeyword(item) {
      console.log("videoSearchKeyword()#keyword->" + item.keyword)
      this.requestForm.videoName = item.keyword;
      this.requestForm.pageIndex = 1;
      this.requestForm.channelId = 0;
      this.requestForm.classId = 0;
      if (!this.hotVideo) {
        this.loadData();
      }
    },
    videoFilterItem(item) {
      this.requestForm.pageIndex = 1;
      this.requestForm.channelId = item.channelItem.id;
      this.requestForm.classId = item.classItem.id;
      // if (!this.hotVideo) {
      this.loadData();
      // }
    }
  },
}

</script>

<style scoped>
.grid-session-box {
  box-sizing: border-box;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(var(--videoColumnNum), var(--videoColumnPercentage));
  grid-template-rows: repeat(auto-fill, 15rem);
  grid-gap: 1rem 0.1rem;
  grid-auto-flow: row dense;
}

.grid-item {
  box-sizing: border-box;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bolder;
  font-size: 20px;
}

.grid-item:first-of-type {
  grid-column-start: 1;
  grid-column-end: var(--gridEnd);
  grid-row-start: 1;
  grid-row-end: var(--gridEnd);
}

</style>
